// Let the browser stream the attachment to disk without allocating a large Blob.
export function browserDownload(url, ticket) {
  const frame = document.createElement('iframe');
  frame.name = `installer-download-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  frame.hidden = true;
  frame.title = 'Download do instalador';
  frame.referrerPolicy = 'no-referrer';
  document.body.appendChild(frame);
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.target = frame.name;
  form.hidden = true;
  const field = document.createElement('input');
  field.type = 'hidden'; field.name = 'ticket'; field.value = ticket;
  form.appendChild(field);
  document.body.appendChild(form);
  try { form.submit(); }
  catch (error) { frame.remove(); throw error; }
  finally { form.remove(); }
  // Keep the frame alive: removing it on a timer can cancel a slow transfer.
}
